import axiosInstance from './axios';

export interface QrResolveResponse {
  path: string;
}

/**
 * Resolve a scanned QR token to the frontend path it should open.
 * Public endpoint — no auth required. 404s if the token is unknown or the
 * owning item is currently disabled (qr_enabled=False).
 */
export const resolveQrToken = async (token: string): Promise<QrResolveResponse> => {
  const response = await axiosInstance.get(`/qr/${encodeURIComponent(token)}`);
  return response.data;
};
